<template>

  <q-page class="flex-center">
    <div class="q-pa-md">
      <q-card-section>
        <q-tabs
          v-model="tab"
          dense
          class="text-grey"
          active-color="primary"
          indicator-color="primary"
          align="justify"
          narrow-indicator
        >
          <q-tab name="basic" label="Dados básicos"></q-tab>
          <q-tab name="payment_form" label="Dados de pagamento" :disable="two" ref="payment_form"></q-tab>
          <q-tab name="address" label="Endereço" ref="address" :disable="three"></q-tab>
        </q-tabs>

        <q-separator></q-separator>

        <q-tab-panels v-model="tab" animated>
          <q-tab-panel name="basic">
            <div class="q-pa-md">
              <div class="row q-col-gutter-xs">
                <q-form class="col-12" @submit.prevent.stop="stepTwo">
                  <div class="row q-col-gutter-xs">
                    <div class="col-4">
                      <q-select
                        outlined
                        v-model="donator.payment_form_id"

                        options-dense
                        map-options

                        label="Forma de Pagamento"
                        :options="formaPagamentoOptions"
                        option-value="id"
                        option-label="name"
                        style="min-width: 150px"
                      />
                    </div>
                    <div class="col-4">
                      <q-radio v-model="donator.person_type" val="F" label="Pessoa Física"/>
                      <q-radio v-model="donator.person_type" val="J" label="Pessoa Jurídica"/>
                    </div>
                    <div class="col-4">
                      <q-input outlined v-model="donator.name" :label="labelFirst"
                               :rules="[required]"/>
                    </div>
                    <div class="col-4">
                      <q-input outlined v-model="donator.last_name" :label="labelLast"
                               :rules="[required]"/>
                    </div>
                    <div class="col-4">
                      <q-input outlined v-model="donator.email" label="E-mail" @blur="donatorByEmailBlur"
                               :rules="[validaEmail]"/>
                    </div>
                    <div class="col-4">
                      <q-input outlined v-model="donator.document" :label="labelDocument" :mask="maskDocument" unmasked-value
                               @blur="donatorByCPFBlur"
                               :rules="[required, this.valida]"/>
                    </div>
                    <div class="col-4">
                      <q-input outlined v-model="donator.tel_res" :label="labelTel" mask="(##) ####-####"
                              />
                    </div>
                    <div class="col-4">
                      <q-input outlined v-model="donator.tel_cel" mask="(##) # ####-####" label="Telefone celular"
                               :rules="[required]"/>
                    </div>

                    <div class="col-4">
                      <q-select
                                outlined
                                v-model="donator.donator_status_id"
                                :rules="[required]"
                                options-dense
                                map-options
                                label="Status do doador"
                                :options="statusDoadorOptions"
                                option-value="id"
                                option-label="name"

                                style="min-width: 150px"
                      />
                    </div>

                    <div class="col-4">
                      <q-select
                                outlined
                                v-model="donator.shipping_method_id"
                                options-dense
                                map-options
                                label="Forma de Envio"
                                :options="formaEnvioOptions"
                                option-value="id"
                                option-label="name"

                                style="min-width: 150px"
                      />
                    </div>
                    <div class="col-4">
                      <q-select
                                outlined
                                v-model="donator.donator_type_id"
                                :rules="[required]"
                                options-dense
                                map-options
                                label="Tipo do doador"
                                :options="tipoDoadorOptions"
                                option-value="id"
                                option-label="name"

                                style="min-width: 150px"
                      />

                    </div>
                    <div class="col-4">
                      <q-input outlined v-model="donator.birthday" label="Data de nascimento" mask="##/##/####"
                               :rules="[required]"/>
                    </div>
                    <div class="col-4" v-if="person == 'F'">
                      <q-radio v-model="donator.sex" val="M" label="Masculino"/>
                      <q-radio v-model="donator.sex" val="F" label="Feminino"/>
                    </div>
                    <!--<div class="col-4">
                      <q-radio v-model="donator.person_type" val="1" label="Pessoa jurídica"/>
                      <q-radio v-model="donator.person_type" val="2" label="Pessoa física"/>
                    </div>-->
                  </div>
                  <br>
                  <q-btn label="Prosseguir" type="submit" color="primary"/>
                </q-form>
              </div>
            </div>

          </q-tab-panel>

          <q-tab-panel name="payment_form">
            <div class="text-h6"></div>
            <div class="q-pa-md">
              <div class="row q-col-gutter-xs">
                <q-form class="col-12" @submit.prevent.stop="stepThree">
                  <div class="row q-col-gutter-xs">

                    <div class="col-4">
                      <q-select
                                outlined
                                v-model="donator.bank"

                                options-dense
                                map-options

                                label="Banco"
                                :options="bankOptions"
                                option-value="id"
                                option-label="name"
                                style="min-width: 150px"
                      />
                    </div>
                    <div class="col-4">
                      <q-input outlined v-model="donator.maturity_day" unmasked-value
                               label="Dia de recorrência"/>
                    </div>

                    <div class="col-4">
                      <q-input outlined v-model="donator.agency"
                               label="Agência bancária" mask="####"/>
                    </div>
                    <div class="col-4">
                      <q-input outlined v-model="donator.bank_account"
                               label="Conta bancária"/>
                    </div>
                    <div class="col-4">
                      <q-input outlined v-model="donator.recurrence_value" unmasked-value
                               mask="R$ ######.###,##"
                               label="Valor"/>
                    </div>

                    <div class="col-4">
                      <q-input outlined v-model="donator.card_number"
                               label="Número do cartão" mask="####.####.####.####"/>
                    </div>
                    <div class="col-4">
                      <q-input outlined v-model="donator.card_maturity" mask="##/##"
                               label="Vencimento do cartão"/>
                    </div>
                  </div>
                  <br>

                  <q-btn label="Prosseguir" type="submit" color="primary"/>
                </q-form>
              </div>

            </div>
          </q-tab-panel>

          <q-tab-panel name="address">
            <div class="q-pa-md">
              <div class="row q-col-gutter-xs">
                <q-form class="col-12" @submit.prevent.stop="final">
                  <div class="row q-col-gutter-xs">
                    <div class="col-4">
                      <q-input outlined v-model="donator.zipcode" label="CEP" @blur="onZipCode" mask="#####-###"
                               :rules="[required]"/>
                    </div>
                    <div class="col-4">
                      <q-input outlined v-model="donator.street" label="Logradouro"
                               :rules="[required]"/>
                    </div>
                    <div class="col-4">
                      <q-input outlined v-model="donator.number" label="Número"
                               :rules="[required]"/>
                    </div>
                    <div class="col-4">
                      <q-input outlined v-model="donator.complement" label="Complemento"
                      />
                    </div>
                    <div class="col-4">
                      <q-input outlined v-model="donator.neighborhood" label="Bairro"
                               :rules="[required]"/>
                    </div>

                    <div class="col-4">
                      <q-input outlined v-model="donator.city" label="Cidade"
                               :rules="[required]"/>
                    </div>
                    <div class="col-4">
                      <q-input outlined v-model="donator.state" label="Estado"
                               :rules="[required]"/>
                    </div>
                  </div>
                  <br>
                  <q-btn label="Salvar" type="submit" color="primary"/>
                </q-form>
              </div>
            </div>
          </q-tab-panel>
        </q-tab-panels>
      </q-card-section>
    </div>
    <q-dialog v-model="created">
      <q-card>
        <q-card-section>
          <div class="text-h6">Sucesso!</div>
        </q-card-section>

        <q-card-section>
          O doador foi salvo com sucesso!
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="OK" color="primary" @click="retorna"/>
        </q-card-actions>
      </q-card>
    </q-dialog>
    <q-dialog v-model="document">
      <q-card>
        <q-card-section>
          <div class="text-h6">Erro!</div>
        </q-card-section>

        <q-card-section>
          Este documento já está na base de dados!
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="OK" color="primary" @click="document = false"/>
        </q-card-actions>
      </q-card>
    </q-dialog>
    <q-dialog v-model="email">
      <q-card>
        <q-card-section>
          <div class="text-h6">Erro!</div>
        </q-card-section>

        <q-card-section>
          Este e-mail já está na base de dados!
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="OK" color="primary" @click="email = false"/>
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { DONATOR_BY_CPF, DONATOR_BY_EMAIL, REGISTER_DONATOR } from '../graphql/graphql'

export default {
  name: 'Doador',
  props: {
    donator_id: {
      type: String
    },
    donator_name: {
      type: String
    }
  },
  apollo: {
    RegisterDonatorSite: {
      query: REGISTER_DONATOR,
      variables () {
        return {
          donator: this.donator
        }
      },
      skip: true
      // pollInterval: 300, // ms
    },
    donatorByEmail: {
      query: DONATOR_BY_EMAIL,
      variables () {
        return {
          email: this.donator.email
        }
      },
      skip: true
      // pollInterval: 300, // ms
    },
    donatorByCPF: {
      query: DONATOR_BY_CPF,
      variables () {
        return {
          cpf: this.donator.document
        }
      },
      skip: true
      // pollInterval: 300, // ms
    }
  },
  data () {
    return {
      person: '',
      document: false,
      email: false,
      tab: 'basic',
      created: false,
      two: true,
      three: true,
      labelFirst: 'Primeiro Nome',
      labelLast: 'Último Nome',
      labelDocument: 'CPF',
      maskDocument: '',
      labelTel: 'Telefone residencial',
      donator: {
        sex: 'M',
        neighborhood: '',
        complement: '',
        city: '',
        state: '',
        street: '',
        country: 'BR',
        document: '',
        email: '',
        last_name: '',
        number: '',
        birthday: '',
        zipcode: '',
        tel_res: '',
        tel_cel: '',
        bank: '',
        informative: 1,
        card_matutiry: ''
      },
      loading: true,
      dense: false,
      formaPagamentoOptions: [
        { id: 1, name: 'Boleto' },
        { id: 9, name: 'Cartão de crédito' },
        { id: 11, name: 'Débito automático' },
        { id: 12, name: 'PayPal' },
        { id: 13, name: 'Transferência Identificada' },
        { id: 14, name: 'Transferência sem relacionamento' },
        { id: 15, name: 'Pólen' },
        { id: 16, name: 'Presente solidário' }
      ],
      statusDoadorOptions: [
        { id: 1, name: 'Ativo' },
        { id: 4, name: 'Atraso 1' },
        { id: 2, name: 'Atraso 2' },
        { id: 9, name: 'Inativo' },
        { id: 13, name: 'Cancelado' }
      ],
      formaEnvioOptions: [
        { id: 1, name: 'Correio' },
        { id: 2, name: 'E-mail' }
      ],
      bankOptions: [
        { id: 341, name: 'Itaú' },
        { id: '033', name: 'Santander' }
      ],
      tipoDoadorOptions: [
        { id: 1, name: 'Regular' },
        { id: 2, name: 'Único' },
        { id: 3, name: 'Ocasional' }
      ],
      donatorByEmail: {},
      donatorByCPF: {},
      emailPattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    }
  },
  methods: {
    required (value) {
      // alert(JSON.stringify(this.donator.payment_form_id.id))
      if (this.donator.payment_form_id.id < 12) {
        return !!value || 'Campo obrigatório'
      }
    },
    validaEmail (email) {
      if (this.donator.payment_form_id.id < 12) {
        return this.emailPattern.test(email) || 'Necessário um e-mail válido'
      }
    },
    retorna () {
      this.created = false
      this.$router.push({ name: 'doadores' })
    },
    valida: function (ev) {
      if (this.donator.payment_form_id.id < 12) {
        if (this.person === 'F') {
          const mod11 = (num) => num % 11
          const NOT = (x) => !x
          const isEqual = (a) => (b) => b === a
          const mergeDigits = (num1, num2) => `${num1}${num2}`
          const getTwoLastDigits = (cpf) => `${cpf[9]}${cpf[10]}`
          const getCpfToCheckInArray = (cpf) => cpf.substr(0, 9).split('')
          const generateArray = (length) => Array.from({ length }, (v, k) => k)

          const isIn = (list) => (value) =>
            list.findIndex(v => value === v) >= 0

          const isSameDigitsCPF = (cpfFull) =>
            isIn(generateArray(10).map(generateStringSequence(11)))(cpfFull)

          const generateStringSequence = (times) => (char) =>
            (`${char}`.repeat(times))

          const toSumOfMultiplication = (total) => (result, num, i) =>
            result + (num * total--)

          const getSumOfMultiplication = (list, total) =>
            list.reduce(toSumOfMultiplication(total), 0)

          const getValidationDigit = (total) => (cpf) =>
            getDigit(mod11(getSumOfMultiplication(cpf, total)))

          const getDigit = (num) =>
            (num > 1)
              ? 11 - num
              : 0

          const isValidCPF = (cpfFull) => {
            const cpf = getCpfToCheckInArray(cpfFull)
            const firstDigit = getValidationDigit(10)(cpf)
            const secondDigit = getValidationDigit(11)(cpf.concat(firstDigit))

            return isEqual(getTwoLastDigits(cpfFull))
            (mergeDigits(firstDigit, secondDigit))
          }

          const validate = (CPF) => NOT(isSameDigitsCPF(CPF)) && isValidCPF(CPF)

          return validate(ev) || 'CPF inválido'
        } else {
          let cnpj = ev.replace(/[^\d]+/g, '')

          if (cnpj === '') return false

          if (cnpj.length !== 14) {
            return false
          }

          // Elimina CNPJs invalidos conhecidos
          if (cnpj === '00000000000000' ||
            cnpj === '11111111111111' ||
            cnpj === '22222222222222' ||
            cnpj === '33333333333333' ||
            cnpj === '44444444444444' ||
            cnpj === '55555555555555' ||
            cnpj === '66666666666666' ||
            cnpj === '77777777777777' ||
            cnpj === '88888888888888' ||
            cnpj === '99999999999999') {
            return false
          }

          // Valida DVs
          tamanho = cnpj.length - 2
          // eslint-disable-next-line no-undef
          numeros = cnpj.substring(0, tamanho)
          // eslint-disable-next-line no-undef
          digitos = cnpj.substring(tamanho)
          soma = 0
          pos = tamanho - 7
          for (i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--
            if (pos < 2) {
              pos = 9
            }
          }
          resultado = soma % 11 < 2 ? 0 : 11 - soma % 11
          if (resultado != digitos.charAt(0)) {
            return false
          }

          tamanho = tamanho + 1
          numeros = cnpj.substring(0, tamanho)
          soma = 0
          pos = tamanho - 7
          for (i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--
            if (pos < 2) {
              pos = 9
            }
          }
          resultado = soma % 11 < 2 ? 0 : 11 - soma % 11

          return resultado != digitos.charAt(1) || 'CNPJ inválido'
        }
      }
      return true
    },
    close () {
      this.$emit('closeDonator')
    },
    formatDate (date) {
      return DateTime.fromSQL(date, {
        locale:
                        'pt-br'
      }).toLocaleString()
    },
    stepTwo (data) {
      this.two = false
      this.tab = 'payment_form'
    },
    stepThree (data) {
      this.three = false
      this.tab = 'address'
    },
    donatorByEmailBlur () {
      if (this.donator.payment_form_id.id < 12) {
        this.$apollo.addSmartQuery('donatorByEmail', {
          query: DONATOR_BY_EMAIL,
          variables () {
            return {
              'email': this.donator.email
            }
          },
          // pollInterval: 300,
          update (store, data) {
            if (store.donatorByEmail.length > 0) {
              this.email = true
              this.donator.email = ''
            }
          }
        })
      }
    },
    donatorByCPFBlur () {
      if (this.donator.payment_form_id.id < 12) {
        this.$apollo.addSmartQuery('donatorByCPF', {
          query: DONATOR_BY_CPF,
          variables () {
            return {
              'cpf': this.donator.document
            }
          },
          // pollInterval: 300,
          update (store, data) {
            if (store.donatorByCPF.length > 0) {
              this.document = true
              this.donator.document = ''
            }
          }
        })
      }
    },
    final (data) {
      this.$apollo.mutate({
        mutation: REGISTER_DONATOR,
        variables: {
          name: this.donator.name,
          document: this.donator.document,
          email: this.donator.email,
          last_name: this.donator.last_name,
          street: this.donator.street,
          number: this.donator.number,
          complement: this.donator.complement,
          neighborhood: this.donator.neighborhood,
          person_type: this.donator.person_type,
          city: this.donator.city,
          birthday: this.donator.birthday,
          state: this.donator.state,
          zipcode: this.donator.zipcode,
          tel_res: this.donator.tel_res,
          tel_com: this.donator.tel_com,
          country: this.donator.country,
          tel_cel: this.donator.tel_cel,
          sex: this.donator.sex,
          informative: this.donator.informative,
          recurrence_value: this.donator.recurrence_value,
          maturity_day: this.donator.maturity_day,
          donator_status_id: this.donator.donator_status_id ? this.donator.donator_status_id.id : 1,
          shipping_method_id: this.donator.shipping_method_id ? this.donator.shipping_method_id.id : 1,
          donator_type_id: this.donator.donator_type_id ? this.donator.donator_type_id.id : 1,
          payment_form_id: this.donator.payment_form_id.id,
          bank: this.donator.bank.id,
          bank_account: this.donator.bank_account,
          agency: this.donator.agency,
          card_number: this.donator.card_number,
          card_matutiry: this.donator.card_matutiry
        },
        update: (store, data) => {
          this.created = true
        }
      })
        .catch(error => {
          const errors = { error }
          console.log(error)
          console.log(errors)
        })
    },
    onZipCode () {
      const cep = this.donator.zipcode.replace('.', '').replace('-', '')
      fetch(`//viacep.com.br/ws/${cep}/json/`).then(res => res.json()).then(res => {
        this.donator.neighborhood = res.bairro
        this.donator.complement = res.complemento
        this.donator.city = res.localidade
        this.donator.state = res.uf
        this.donator.street = res.logradouro
        // console.log(res)
      })
    }
  },
  computed: {
    maskBank () {
      return this.masks[this.donator.bank]
    }
  },
  watch: {
    person: function (newVal, oldVal) {
      if (newVal === 'F') {
        this.donator.person_type = 'F'
        this.labelFirst = 'Primeiro Nome'
        this.labelLast = 'Último Nome'
        this.labelDocument = 'CPF'
        this.labelTel = 'Telefone Residencial'
        this.maskDocument = '###.###.###-##'
      }
      if (newVal === 'J') {
        this.donator.person_type = 'J'
        this.labelFirst = 'Nome Fantasia'
        this.labelLast = 'Razão Social'
        this.labelDocument = 'CNPJ'
        this.labelTel = 'Telefone comercial'
        this.maskDocument = '##.###.###/####-##'
      }
    }
  }
}
</script>

<style scoped>

</style>
